;(() => {
  function isTextClamped($elm) {
    return $elm.scrollHeight > $elm.clientHeight
  }

  const $desc = document.getElementById('store-info-description')
  const $text = $desc.querySelector('#store-info-target')
  const $btn = $desc.querySelector('#store-info-more')

  if (!isTextClamped($text)) {
    $btn.classList.add('hidden')
    return
  }

  function getHeight($el) {
    $el.style.height = 'auto'
    const rect = $el.getBoundingClientRect()
    return rect.height
  }

  $btn.addEventListener('click', (e) => {
    e.preventDefault()
    const heightBeforeToggle = getHeight($text)

    const isClamped = $text.classList.toggle('line-clamp-6')
    if (isClamped) {
      $btn.innerText = 'すべて見る'
    } else {
      $btn.innerText = '閉じる'
    }

    const heightAfterToggle = getHeight($text)

    $text.animate(
      [
        { height: heightBeforeToggle + 'px' },
        { height: heightAfterToggle + 'px' },
      ],
      {
        duration: 100,
        easing: 'ease-in-out',
      },
    )
  })
})()
